import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import moment from "moment";
import { KeyboardArrowDown, KeyboardArrowRight } from "@mui/icons-material";
import DefaultMonthDateRangePicker from "pages/TeamZone/Approve/DateRangePicker";
import { InfoMessage } from "components/CustomComponents/CustomButton";
import { showToast } from "services/utils/Status";
import "react-toastify/dist/ReactToastify.css";
import { Loader } from "components/Loader";
import { useSelector } from "react-redux";
import { themes, scrollTop, tableRowSx } from "services/constants";
import sessionHandling from "services/utils/notificationUtils";
import { IncentivePendingHeader } from "../Headers";
import { Cancel } from "@mui/icons-material";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { tooltipStyleProps } from "services/constants/Styles";

export const Pending = () => {
  const { domain, token, userDetails, globalSearchValue } = useSelector(
    (state) => state.tokenReducer
  );
  const [loading, setLoading] = useState(false);
  const [expandedRow, setExpandedRow] = React.useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [filteredData, setFilteredData] = useState([]);
  const [pendingIncentiveDetails, setPendingIncentiveDetails] = useState([]);
  const [cancelConfirmation, setCancelConfirmation] = useState(false);
  const [incentiveId, setIncentiveId] = useState("");
  const containerRef = useRef(null);
  const [buttonLoader, setButtonLoader] = useState(false);

  const handleRowClick = (rowId) => {
    if (expandedRow === rowId) {
      setExpandedRow(null);
    } else {
      setExpandedRow(rowId);
    }
  };

  const handleStartDate = async (startDate, endDate) => {
    let searchStartDate = startDate.split("/").reverse().join("-");
    let searchEndDate = endDate.split("/").reverse().join("-");
    setLoading(true);
    try {
      const response = await fetch(
        `${domain}my-incentive-applications/?user_id=${userDetails.id}&status=Pending&start_date=${searchStartDate}&end_date=${searchEndDate}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        }
      );
      const res = await response.json();
      if (response.ok) {
        setFilteredData(res);
        setPendingIncentiveDetails(res);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
      setLoading(false);
    } catch (error) {
      showToast("error", error.message);
    }
  };

  const handleCancelLeave = async () => {
    setButtonLoader(true);
    try {
      const response = await fetch(
        `${domain}incentive/my-application/cancel/`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
          body: JSON.stringify({
            id: incentiveId,
            status: "Cancelled",
          }),
        }
      );
      const res = await response.json();
      if (response.ok) {
        showToast("error", res?.message);
        setCancelConfirmation(false);
        handleStartDate(
          moment().startOf("month").format("DD/MM/YYYY"),
          moment().endOf("month").format("DD/MM/YYYY")
        );
        setButtonLoader(false);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
    } catch (error) {
      showToast("error", error.message);
      setButtonLoader(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  useEffect(() => {
    const searchFields = [
      "incentive_type",
      "incentive_group_name",
      "start_date",
      "end_date",
      "incentive_amount",
    ];
    const filteredResults = pendingIncentiveDetails.filter((item) =>
      searchFields.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setFilteredData(filteredResults);
    setPage(0);
  }, [globalSearchValue, pendingIncentiveDetails]);

  const handelCalcelOt = (event) => {
    setCancelConfirmation(false);
  };

  return (
    <React.Fragment>
      <Mui.Grid container>
        <Mui.Grid item xs={9.25}></Mui.Grid>
        <Mui.Grid item xs={2.6} sx={{ paddingTop: 1, marginTop: -7 }}>
          <DefaultMonthDateRangePicker
            handleStartDate={handleStartDate}
            showToday={true}
            triggerDate={true}
          />
        </Mui.Grid>
      </Mui.Grid>

      {loading === true ? (
        <Loader info="Loading..." />
      ) : (
        <>
          <Mui.Grid container>
            <Mui.TableContainer
              sx={{ width: "100%", maxHeight: 700, mt: 2, ml: 2, mr: 2 }}
              ref={containerRef}
            >
              <Mui.Table className="border">
                <Mui.TableHead
                  sx={{
                    backgroundColor: themes.primary,
                    position: "sticky",
                    top: -1,
                    zIndex: 10,
                  }}
                >
                  <Mui.TableRow sx={tableRowSx}>
                    {IncentivePendingHeader.map((header) => (
                      <Mui.TableCell
                        sx={{ color: themes.headLine, fontWeight: "bold" }}
                      >
                        {header.name}
                      </Mui.TableCell>
                    ))}
                  </Mui.TableRow>
                </Mui.TableHead>

                <Mui.TableBody>
                  {filteredData?.length === 0 ? (
                    <InfoMessage dataLength={pendingIncentiveDetails} />
                  ) : (
                    filteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((item) => (
                        <>
                          <Mui.TableRow sx={tableRowSx}>
                            {IncentivePendingHeader.map((header) => (
                              <Mui.TableCell
                                sx={{
                                  color: themes.headLine,
                                  width:
                                    header.key === "arrow"
                                      ? "1%"
                                      : header.key === "incentive_group_name"
                                      ? "15%"
                                      : "10%",
                                }}
                              >
                                {header.key === "action" ? (
                                  <Mui.Grid sx={{ color: themes.headLine }}>
                                    <Mui.Tooltip
                                      arrow
                                      slotProps={tooltipStyleProps}
                                      title="Cancel"
                                    >
                                      <Mui.IconButton
                                        onClick={() => {
                                          setIncentiveId(item?.id);
                                          setCancelConfirmation(true);
                                        }}
                                      >
                                        <Cancel
                                          style={{
                                            color: themes.redColor,
                                            strokeWidth: 2,
                                          }}
                                        />
                                      </Mui.IconButton>
                                    </Mui.Tooltip>
                                  </Mui.Grid>
                                ) : header.key === "arrow" ? (
                                  <>
                                    {expandedRow === item.id ? (
                                      <Mui.IconButton
                                        onClick={() => {
                                          setExpandedRow(null);
                                        }}
                                      >
                                        <KeyboardArrowDown
                                          style={{
                                            color: "black",
                                            fontWeight: "bold",
                                          }}
                                        />
                                      </Mui.IconButton>
                                    ) : (
                                      <Mui.IconButton
                                        onClick={() => handleRowClick(item.id)}
                                      >
                                        <KeyboardArrowRight
                                          style={{
                                            color: "black",
                                            fontWeight: "bold",
                                          }}
                                        />
                                      </Mui.IconButton>
                                    )}
                                  </>
                                ) : item[header.key] ? (
                                  item[header.key]
                                ) : (
                                  "N/A"
                                )}
                              </Mui.TableCell>
                            ))}
                          </Mui.TableRow>
                          {expandedRow === item.id && (
                            <Mui.TableRow>
                              <Mui.TableCell colSpan={10}>
                                <Mui.TableContainer
                                  sx={{
                                    width: "100%",
                                    maxHeight: 700,
                                    mt: 0.5,
                                  }}
                                  className="w-96 border rounded"
                                >
                                  <Mui.Table className="border">
                                    <Mui.Grid sx={{ padding: 0.5 }}>
                                      <Mui.Grid
                                        container
                                        sx={{ paddingTop: 1, paddingLeft: 2 }}
                                      >
                                        <Mui.Stack direction="row">
                                          <Mui.Typography
                                            sx={{ fontWeight: "bold" }}
                                          >
                                            Applied by
                                          </Mui.Typography>
                                          <Mui.Typography
                                            sx={{ paddingLeft: 1 }}
                                          >
                                            {item?.appliedby
                                              ? item?.appliedby
                                              : "-"}
                                          </Mui.Typography>
                                          <Mui.Typography
                                            sx={{
                                              fontWeight: "bold",
                                              paddingLeft: 1,
                                            }}
                                          >
                                            on
                                          </Mui.Typography>
                                          <Mui.Typography
                                            sx={{ paddingLeft: 1 }}
                                          >
                                            {item?.appliedat
                                              ? item?.appliedat
                                              : "-"}
                                          </Mui.Typography>
                                        </Mui.Stack>
                                      </Mui.Grid>
                                      <Mui.Grid
                                        container
                                        sx={{ paddingTop: 1, paddingLeft: 2 }}
                                      >
                                        <Mui.Stack
                                          direction="row"
                                          flexWrap="wrap"
                                        >
                                          <Mui.Typography
                                            sx={{
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Description :
                                          </Mui.Typography>
                                          <Mui.Typography
                                            sx={{
                                              paddingLeft: 1,
                                              whiteSpace: "normal",
                                              wordBreak: "break-word",
                                              flex: "1 1 0",
                                            }}
                                          >
                                            {item.description ?? "N/A"}
                                          </Mui.Typography>
                                        </Mui.Stack>
                                      </Mui.Grid>
                                    </Mui.Grid>
                                  </Mui.Table>
                                </Mui.TableContainer>
                              </Mui.TableCell>
                            </Mui.TableRow>
                          )}
                        </>
                      ))
                  )}
                </Mui.TableBody>
              </Mui.Table>
            </Mui.TableContainer>
          </Mui.Grid>
          {filteredData.length > 25 && (
            <Mui.TablePagination
              className="custom-pagination"
              rowsPerPageOptions={[25, 50, 75, 100]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}

          <GlobalDialogBox
            handleCloseDialog={handelCalcelOt}
            open={cancelConfirmation}
            title="Cancel Incentive Request"
          >
            <Mui.Grid container>
              <Mui.Grid item xs={12}>
                <Mui.Typography fontSize={22}>
                  Are you sure you want to cancel this incentive request?
                </Mui.Typography>
                <Mui.Typography fontSize={22}>
                  This action cannot be undone.
                </Mui.Typography>
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container>
              <Mui.Grid item xs={8}></Mui.Grid>
              <Mui.Grid item xs={2}>
                <CustomButton
                  actionFuntion={handelCalcelOt}
                  actionName="No"
                  typeName="button"
                />
              </Mui.Grid>
              <Mui.Grid item xs={2}>
                <CustomButton
                  actionFuntion={() => handleCancelLeave()}
                  actionName="Yes"
                  typeName="button"
                  disableAction={buttonLoader}
                />
              </Mui.Grid>
            </Mui.Grid>
          </GlobalDialogBox>
        </>
      )}
    </React.Fragment>
  );
};
